import React, { useEffect, useState } from "react";
import styles from './ProductFilters.module.css';
import { useSearchParams } from "react-router-dom";

export default function ProductFilters({array,productFilters,setProductFilters}){

    const [searchParams,setSearchParams] = useSearchParams();
    const [manualChangeMade,setManualChangeMade] = useState(false);

    const filterName = JSON.parse(searchParams.get('filterName'));

    useEffect(() => {
        if(array.length > 0) {
            const uniqueCategories = [...new Set(array.map((item) => item.category))];
            const filters = uniqueCategories.map((category) => {
                if(filterName && filterName.length > 0 && filterName.some((name) => name === category)){
                    let obj;
                    filterName.forEach((filter) => {
                        if(filter === category){
                            obj = {
                                category,
                                filterOn: true
                            }
                        }
                    });
                    return obj;
                }
                 else {
                    return {
                        category,
                        filterOn: false
                    }
                } 
            });
            if(manualChangeMade){
                setManualChangeMade(false);
            } else {
                setProductFilters(filters);
            }
        }
    },[array,searchParams]);

    const filterOption = (category) => {
        return (
            <div onClick={() => toggleFilter(category.category)} className={`${styles.filterButton} ${category.filterOn? styles.filterOn : ''}`}>{category.category}</div>
        )
    }

    const toggleFilter = (category) => {
        setProductFilters((prev) => {
            let newArray = [...prev];
            const index = newArray.findIndex((filter) => filter.category === category);
            if(index > -1){
                newArray[index] = {
                    ...newArray[index],
                    filterOn: !newArray[index].filterOn
                }
            }
            if(newArray.every((filter) => filter.filterOn)){
                newArray = newArray.map((filter) => {
                    return {
                        ...filter,
                        filterOn: false
                    }
                })
            }
            const searchArray = newArray.filter((filter) => filter.filterOn).map((filter) => filter.category);
            if(searchArray.length > 0){
                setSearchParams({filterName: JSON.stringify(searchArray)});
            } else {
                setSearchParams({});
            }
            setManualChangeMade(true);
            return newArray;
        })
    }

    const clearAllFilters = () => {
        setProductFilters((prev) => {
            const newArray = [...prev].map((filter) => {
                const newObj = {
                    category: filter.category,
                    filterOn: false
                }
                return newObj;
            });
            const searchArray = newArray.filter((filter) => filter.filterOn).map((filter) => filter.category);
            if(searchArray.length > 0){
                setSearchParams({filterName: JSON.stringify(searchArray)});
            } else {
                setSearchParams({});
            }
            setManualChangeMade(true);
            return newArray;
        })
    }

    return (
        <div className={styles.filterContainer}>
            <div className={`${styles.filterDiv} ${styles.start}`}>
                <div onClick={clearAllFilters} className={`${styles.filterButton} ${productFilters.every((filter) => !filter.filterOn)? styles.filterOn : ''}`}>All</div>
            </div>
            <div className={`${styles.filterDiv}`}>
                {productFilters.map((category) => filterOption(category))}
            </div>
        </div>
    )
}